var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgClose01 = function SvgClose01(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.3 26.3",
    enableBackground: "new 0 0 26.3 26.3",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.1,2C7,2,2,7,2,13.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1S19.3,2,13.1,2z M19.5,17.5L18,18.9l-4.7-4.7 l-4.7,4.7l-1.4-1.4l4.7-4.7L7.2,8l1.4-1.4l4.7,4.7L18,6.6L19.5,8l-4.7,4.7L19.5,17.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "color",
    fill: "#000",
    points: "18,6.6 13.3,11.4 8.6,6.6 7.2,8 11.9,12.8 7.2,17.5 8.6,18.9 13.3,14.2 18,18.9 19.5,17.5 14.7,12.8 19.5,8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "color",
    fill: "#000",
    d: "M13.1,0C5.9,0,0,5.9,0,13.1s5.9,13.1,13.1,13.1s13.1-5.9,13.1-13.1S20.4,0,13.1,0z M13.1,24.3 C7,24.3,2,19.3,2,13.1S7,2,13.1,2s11.1,5,11.1,11.1S19.3,24.3,13.1,24.3z"
  }))));
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-01.33feb088.svg";
export { ForwardRef as ReactComponent };